import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-628">
        {label && <label htmlFor={textareaId} className="block text-sm font-semibold text-white mb-2" data-id="element-629">
            {label}
          </label>}
        <textarea ref={ref} id={textareaId} className={`w-full px-4 py-3 bg-dark-surface text-white border-2 border-dark-border rounded-industrial focus:outline-none focus:border-brand-yellow transition-colors resize-vertical min-h-[120px] ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-630" />
        {error && <p className="mt-1 text-sm text-red-500" role="alert" data-id="element-631">
            {error}
          </p>}
      </div>;
});
Textarea.displayName = 'Textarea';